import React from "react";
import { BadgeProps, BadgeGreen } from "./Badge";

export const PaidBadge = (props: BadgeProps): React.ReactElement => (
  <BadgeGreen {...props} icon={"FILE_DOCUMENT_CHECK_OUTLINE"}>
    Invoice paid
  </BadgeGreen>
);
